import React from 'react';
import { CheckIcon, PackageIcon } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="w-full py-12 md:py-24 bg-gradient-to-br from-sage-500 to-navy-600 text-white" data-id="element-90">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-91">
        <div className="text-center mb-12" data-id="element-92">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl" data-id="element-93">
            Your Upgrade Kit to Better Mornings
          </h2>
          <p className="mx-auto max-w-[700px] text-white/80 md:text-xl mt-4" data-id="element-94">
            Get everything you need to quit caffeine and level up your focus —
            with zero risk.
          </p>
        </div>
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-2xl overflow-hidden" data-id="element-95">
          <div className="p-8 bg-gradient-to-r from-sage-100 to-navy-100" data-id="element-96">
            <div className="flex justify-between items-center mb-6" data-id="element-97">
              <div data-id="element-98">
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-99">
                  FocusFlow Starter Pack
                </h3>
                <p className="text-sage-600 font-medium" data-id="element-100">30-Day Supply</p>
              </div>
              <div className="text-right" data-id="element-101">
                <p className="text-3xl font-bold text-gray-900" data-id="element-102">$35</p>
                <p className="text-sm text-gray-500" data-id="element-103">Only $1.17 per serving</p>
              </div>
            </div>
            <div className="space-y-4" data-id="element-104">
              <div className="flex items-start" data-id="element-105">
                <CheckIcon className="h-5 w-5 text-sage-600 mr-2 mt-0.5" data-id="element-106" />
                <p className="text-gray-700" data-id="element-107">
                  <span className="font-medium" data-id="element-108">30-day supply</span> of
                  FocusFlow (30 servings)
                </p>
              </div>
              <div className="flex items-start" data-id="element-109">
                <CheckIcon className="h-5 w-5 text-sage-600 mr-2 mt-0.5" data-id="element-110" />
                <p className="text-gray-700" data-id="element-111">
                  <span className="font-medium" data-id="element-112">Premium bamboo scoop</span> for
                  perfect measurements
                </p>
              </div>
              <div className="flex items-start" data-id="element-113">
                <CheckIcon className="h-5 w-5 text-sage-600 mr-2 mt-0.5" data-id="element-114" />
                <p className="text-gray-700" data-id="element-115">
                  <span className="font-medium" data-id="element-116">The Morning Ritual Guide</span>{' '}
                  (PDF)
                </p>
              </div>
              <div className="flex items-start" data-id="element-117">
                <CheckIcon className="h-5 w-5 text-sage-600 mr-2 mt-0.5" data-id="element-118" />
                <p className="text-gray-700" data-id="element-119">
                  <span className="font-medium" data-id="element-120">Private invite</span> to the
                  FocusFlow community (12,000+ strong)
                </p>
              </div>
              <div className="flex items-start" data-id="element-121">
                <CheckIcon className="h-5 w-5 text-sage-600 mr-2 mt-0.5" data-id="element-122" />
                <p className="text-gray-700" data-id="element-123">
                  <span className="font-medium" data-id="element-124">Free shipping</span> + 30-day
                  money-back guarantee
                </p>
              </div>
            </div>
          </div>
          <div className="p-8 bg-white text-center" data-id="element-125">
            <p className="text-gray-500 mb-6" data-id="element-126">
              Over 350 people are already on the waitlist. Reserve your starter
              pack before we sell out again.
            </p>
            <a href="https://shop.focusflowblend.com/products/focus-flow-starter-pack" className="w-full py-3 px-6 text-lg font-medium text-white bg-sage-600 rounded-md hover:bg-sage-700 transition-colors flex items-center justify-center" data-id="element-127">
              <PackageIcon className="mr-2 h-5 w-5" data-id="element-128" />
              CLAIM MY STARTER PACK
            </a>
            <p className="text-sm text-gray-500 mt-4" data-id="element-129">
              Risk-Free. High-Performance Approved. Built For Better Mornings.
            </p>
          </div>
        </div>
      </div>
    </section>;
}